const ENDPOINT = "https://api.planmychutti.in";
export default ENDPOINT;
